import React from 'react';
import './News.scss';

function News() {
    return <>News</>;
}

export default News;
